// extracted by mini-css-extract-plugin
export default {"playerQueue":"PiedtqwSgXUhThRKLdX6"};